module.exports = __webpack_public_path__ + "static/Canela-Regular-4f46eae8b17d150bd741620668aefb2f.otf";